import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import { FormField, Link, SegmentedControl, Slider, SpaceBetween, Steps } from "@cloudscape-design/components";
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from "@cloudscape-design/components/header";
import { format } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


const pageSize = 20;
export const MembersEtcCamerasPage = () => {

    //const storeAdmin = useStoreAdmin();
    const { menu } = useGlobalState();
    useGlobalState();

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [cameras, setCameras] = useState<any[]>([]);
    const [camera, setCamera] = useState("P25");
    const [url, setUrl] = useState("");

    const [cameraIndex, setCameraIndex] = useState(0);
    const currentCameraIndex = cameraIndex;
    const currentTimestamp = cameras[currentCameraIndex]?.timestamp || cameras[0]?.timestamp || 0;

    const totalCameras = cameras.length;
    const lastIndex = totalCameras > 0 ? totalCameras - 1 : 0;

    const formatTimestampFull = (index: any) => {
        if (cameras[index]) {
            return format(new Date(cameras[index].timestamp * 1000), "MMM d, yyyy HH:mm");
        }
        return '';
    };

    const handleRefresh = useCallback(async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/public.aspx`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/public/cameras/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    camera: camera
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.cameras) {
                setCameras(data.cameras)
                setUrl(data.cameras[0]?.url || "")
                setCameraIndex(0)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }, [camera, setLoading]);
    useEffect(() => {
        if (camera !== "") {
            //console.log("Cameras Refresh for: " + camera)
            handleRefresh()
        }
    }, [camera]);
    const paginated = cameras.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <Favorites />

                    }>Cámaras</Header>
                    <SegmentedControl
                        selectedId={camera}
                        onChange={({ detail }) =>
                            setCamera(detail.selectedId.toString())
                        }
                        label="Orientación"
                        options={[
                            { text: "Pista 26", id: "P25" },
                            { text: "Pista 08", id: "P07" },
                        ]}
                    />
                    {url !== "" && (
                        <img src={`https://app3.planeadores.cl${url}`} alt="Camera Snapshot" style={{ width: '100%', maxWidth: '800px', height: 'auto' }} />
                    )}
                    {cameras.length > 0 && (
                        <FormField label={"Hora UTC"}>
                            <Steps
                                orientation="horizontal"
                                steps={
                                    cameras.map((camera, index) => ({
                                        status: index === cameraIndex ? "success" : "not-started",
                                        header: <Link variant="info" onClick={() => {
                                            setCameraIndex(index);
                                            const newCamera = cameras[index];
                                            if (newCamera) {
                                                setUrl(`${newCamera.url}`);
                                            }
                                        }}>{camera.time}</Link>
                                    })
                                    )
                                }
                            />
                        </FormField>
                    )}

                </SpaceBetween>
            }
        />
    );
};
